import {
  FiArchive,
  FiBarChart2,
  FiBell,
  FiCheck,
  FiChevronDown,
  FiChevronUp,
  FiChevronsLeft,
  FiChevronsRight,
  FiDollarSign,
  FiEdit2,
  FiHome,
  FiKey,
  FiLayers,
  FiMail,
  FiMoreHorizontal,
  FiPackage,
  FiPhone,
  FiPlus,
  FiSearch,
  FiSettings,
  FiShield,
  FiShoppingCart,
  FiTrash2,
  FiUser,
  FiUserCheck,
  FiUserMinus,
  FiUsers,
} from "react-icons/fi";
import { RiStore2Line } from "react-icons/ri";
import type { IconType } from "react-icons";

export const appIcons = {
  archive: FiArchive,
  barChart: FiBarChart2,
  bell: FiBell,
  check: FiCheck,
  chevronDown: FiChevronDown,
  chevronUp: FiChevronUp,
  chevronsLeft: FiChevronsLeft,
  chevronsRight: FiChevronsRight,
  dollarSign: FiDollarSign,
  edit: FiEdit2,
  home: FiHome,
  key: FiKey,
  layers: FiLayers,
  mail: FiMail,
  moreHorizontal: FiMoreHorizontal,
  package: FiPackage,
  phone: FiPhone,
  plus: FiPlus,
  search: FiSearch,
  settings: FiSettings,
  shield: FiShield,
  shoppingCart: FiShoppingCart,
  store: RiStore2Line,
  trash: FiTrash2,
  user: FiUser,
  userCheck: FiUserCheck,
  userMinus: FiUserMinus,
  users: FiUsers,
} satisfies Record<string, IconType>;

export type AppIconName = keyof typeof appIcons;
